module.exports = __webpack_public_path__ + "static/media/award_1.c6bf8573.jpg";